import { render, staticRenderFns } from "./ResetSetting.vue?vue&type=template&id=4787608a&lang=pug"
import script from "./ResetSetting.vue?vue&type=script&lang=js"
export * from "./ResetSetting.vue?vue&type=script&lang=js"
import style0 from "./ResetSetting.vue?vue&type=style&index=0&id=4787608a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports